<template>
  <div class="view">
    <van-popup v-model="isShow"
      class="overlay-bg"
      position="bottom"
      :style="{ height: '100%' }">
      <van-image
          :src="downBg"
          :height="imgHeight"
          fit="contain"
        />
      </van-popup>
    <div class="c-content tb-20"> 
          <van-image
          radius = "15"
          width = "120"
          :src="icon"
        />
        <div class="icon-title">慈光讲堂</div>
        <van-image
          width = "150"
          @click="down"
          src="https://i.yyii.info/static/ciguang_v1/image/down_android.png"
        />
    </div>
    <div class="c-content"> 
      <div class="c-text">  
        「慈光讲堂」軟件截圖
      </div>     
      <div class="van-hairline--top"></div>
        <van-image
        class="c-image"
          v-for="(item, index) in list" 
          :key="index"
          :src="item"
          fit="contain"
        />
    </div>
    <div class="c-content padding-10"> 
       <van-image
          width = "150"
          @click="down"
          src="https://i.yyii.info/static/ciguang_v1/image/down_android.png"
        />
    </div>
  </div>
</template>
<script>


export default {
  data() {
    return {
      title: '慈光讲堂APP下载',
      info: [],
      list: [
        'https://i.yyii.info/static/ciguang_v1/image/pic04.jpg',
        'https://i.yyii.info/static/ciguang_v1/image/pic01.jpg',
        'https://i.yyii.info/static/ciguang_v1/image/pic03.jpg',
      ],
      icon:'https://i.yyii.info/static/ciguang_v1/image/appLogo.png',
      isShow: false,
      isWx: false,
      loading: true,
      downBg: "https://api.ciguang.org/static/moblie_v1/image/apk-down-bg.png",
      imgHeight: document.documentElement.clientHeight,
      //download:"https://u.jingzong.org/u/cgapp",
      download:"https://i.yyii.info/ciguang_v3_oppo_test.apk",
      //download:"https://i.yyii.info/uploads/temp/ciguang_v3_v20240219_v1.apk",
      iosUrl : "https://itunes.apple.com/cn/app/%E6%85%88%E5%85%89/id1671070627?mt=8",
      //iosUrl : "https://itunes.apple.com/cn/app/慈光講堂/id1342700322?mt=8",
    }
  },
  methods: {
    //返回
    onBack(){
      this.$router.push({ path: `/i` })  
    },
    onLoad(){
      console.log('---');
    },
    down(){
      window.location.href =this.download;
    },
    goTo(){         
        if (this.$tools.getDevice() == 'iPhone') {
            window.location.href = this.iosUrl;
        }
        if(navigator.userAgent.indexOf('oppo') > -1){
          alert('oppo手机')
        }
        alert(navigator.userAgent)
    }
  },
  beforeDestroy() {

  },
  mounted(){
  },
  created() {
    if(this.$tools.IsWeixinOrAlipay()==13){
      this.isWx = true;
      this.isShow = true;
    }else{
      this.goTo();
    }
  },
  metaInfo () {
    return {
      title: this.title
    }
  },
};
</script>
<style  scoped>
.view{
    background-color: #f7f8fa;
    margin-bottom: 70px;  
}
.c-content{
  padding:5px 5px;
  text-align: center;
}
.c-image{
    padding:15px 15px;
    margin: 10px 20px;;
    background-color: #fff;
}
.tb-20{
  padding:20px 0;
}
.padding-10{
  padding:10px 10px;
}
.overlay-bg{
  background-color: #2e2e2e;
}
.c-text{
  padding:10px 0;
  font-size: 22px;
  text-align: center;
}
.icon {
    border-radius: 25px;
}
.icon-title{
  font-size: 22px;
  padding:5px 0 20px 0;
}
</style>